import { useState, useEffect } from 'react';

/**
 * Custom hook for Email metrics
 * Tracks email list growth, gains/losses, and unsubscribes
 */
export const useEmail = (dateRange) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (isRefresh = false) => {
    if (isRefresh) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }
    setError(null);

    try {
      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 800));

      // Mock data for email metrics
      const mockData = {
        metrics: {
          totalList: 8450,
          gained: 342,
          lost: 128,
          unsubscribed: 89,
          netGrowth: 214, // gained - lost
          growthRate: 2.6, // (netGrowth / totalList) * 100
        },
        changes: {
          totalList: 2.6,
          gained: 12.5,
          lost: -8.3,
          unsubscribed: -5.2,
        },
        breakdown: [
          {
            month: 'Jan',
            totalList: 7980,
            gained: 285,
            lost: 112,
            unsubscribed: 78,
          },
          {
            month: 'Feb',
            totalList: 8153,
            gained: 298,
            lost: 125,
            unsubscribed: 85,
          },
          {
            month: 'Mar',
            totalList: 8326,
            gained: 315,
            lost: 142,
            unsubscribed: 92,
          },
          {
            month: 'Apr',
            totalList: 8450,
            gained: 342,
            lost: 128,
            unsubscribed: 89,
          },
        ],
      };

      setData(mockData);
    } catch (err) {
      setError(err.message || 'Failed to fetch email data');
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dateRange]);

  const refetch = () => fetchData(true);

  return {
    data,
    loading,
    refreshing,
    error,
    refetch,
  };
};